import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PdfProcessingState } from '../../../pdf-canvas-item/pdf-services/pdf-manager.service';
import { UploadFileComputerService } from '../../../../../services/upload-file-computer.service';

@Component({
  selector: 'app-upload-pdf-preparing-document',
  templateUrl: './upload-pdf-preparing-document.component.html',
  styleUrls: ['./upload-pdf-preparing-document.component.scss'],
})
export class UploadPdfPreparingDocumentComponent implements OnInit, OnChanges {
  @Input() value: number = 0;
  @Input() fileName = '';
  private _fileSize = 0;
  @Input() set fileSize(value: number) {
    this._fileSize = value;
    this.largeFile = this.uploadFileComputerService.checkFileIsLargeOne(value);
  }
  get fileSize(): number {
    return this._fileSize;
  }
  @Input() processingState: PdfProcessingState = PdfProcessingState.UPLOADING;

  largeFile = false;
  statusText = '';
  readonly statusTextMap: Map<PdfProcessingState, string>;

  constructor(
    private translateService: TranslateService,
    private uploadFileComputerService: UploadFileComputerService,
  ) {
    this.statusTextMap = new Map<PdfProcessingState, string>([
      [PdfProcessingState.UPLOADING, this.translateService.instant('Uploading file...')],
      [PdfProcessingState.PROCESSING, this.translateService.instant('Processing file...')],
      [PdfProcessingState.COMPLETE, this.translateService.instant('Completed')],
    ]);
  }

  ngOnInit(): void {
    this.statusText = this.statusTextMap.get(this.processingState) ?? '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['processingState']) {
      this.statusText = this.statusTextMap.get(this.processingState) ?? '';
    }
  }
}
